import React from 'react'
import { Box, Snackbar } from '@mui/material'
import MuiAlert from '@mui/material/Alert'
import { Batch, IBatch } from 'interfaces/IPremix'
import API from '@aws-amplify/api'
import { useDispatch } from 'react-redux'
import BatchForm from './batchForm'
import { IProduction } from 'interfaces/IProduction'

export default function AddBatch(props: {
  productionData: IProduction
  handleSave: () => void
}) {
  const { productionData, handleSave } = props
  const [batchData, setBatchData] = React.useState<IBatch>(new Batch({}))
  const [isFailureSnackbarOpen, setIsFailureSnackbarOpen] =
    React.useState(false)
  const [isSuccessSnackbarOpen, setIsSuccessSnackbarOpen] =
    React.useState(false)
  const [isLoading, setIsLoading] = React.useState<any>(false)
  const [alertMessage, setAlertMessage] = React.useState('')

  const handleSnackbarClose = (): void => {
    setIsFailureSnackbarOpen(false)
    setIsSuccessSnackbarOpen(false)
  }

  const handleBatchFieldChange = (value: any, key: string): void => {
    setBatchData({ ...batchData, [key]: value })
  }

  const saveBatch = (e: React.SyntheticEvent): void => {
    e.preventDefault()
    setIsLoading(true)
    API.post('products', `/premix/createBatch`, {
      body: {
        ...batchData,
        productionId: productionData.productionId,
        premixId: productionData.premixId,
        productionDisplayId: productionData.productionDisplayId,
        notes: productionData.notes,
      },
    })
      .then((response) => {
        setAlertMessage(`Berhasil menambah no. bets. `)
        setIsSuccessSnackbarOpen(true)
        setBatchData(new Batch({}))
        handleSave()
      })
      .catch((error) => {
        let errorMessage = ''
        try {
          const apiMessage =
            error.response.data.message || error.response.data.error || ''
          errorMessage = Array.isArray(apiMessage)
            ? apiMessage.join(' ')
            : apiMessage
        } catch { }

        if (errorMessage.startsWith('Sudah ada bets nomor')) {
          setAlertMessage(errorMessage)
        } else if (errorMessage.startsWith('Batch number already exists')) {
          const duplicateValue = errorMessage.split(': ')[1] || batchData.batchNumber
          setAlertMessage(`Sudah ada bets nomor '${duplicateValue}'`)
        } else {
          setAlertMessage('Gagal menambah no. bets.')
        }
        setIsFailureSnackbarOpen(true)
        console.error(error.response)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  const dispatch = useDispatch()
  React.useEffect(() => {
    dispatch({ type: 'SET_PAGE_TITLE', payload: 'Buat Bets' })
  }, [dispatch])

  return (
    <Box>
      <BatchForm
        batchData={batchData}
        saveBatch={saveBatch}
        isLoading={isLoading}
        handleBatchFieldChange={handleBatchFieldChange}
        allowProductionDateChange
        productionData={productionData}
      />
      <React.Fragment>
        <Box mt={3} />
      </React.Fragment>
      <Snackbar
        open={isSuccessSnackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <MuiAlert severity="success" elevation={6} variant="filled">
          {alertMessage}
        </MuiAlert>
      </Snackbar>
      <Snackbar
        open={isFailureSnackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <MuiAlert severity="error" elevation={6} variant="filled">
          {alertMessage}
        </MuiAlert>
      </Snackbar>
    </Box>
  )
}
